import { createSlice } from "@reduxjs/toolkit";
import { login } from "../Thunks/AuthThunks";

const initialState = {
  loading: {},
  error: null,
};

export const apiStatusSlice = createSlice({
  name: "apiStatus",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { key, value } = action.payload;
      state.loading[key] = value;
    },
    clearError: (state) => {
      state.error = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Track login loading state
    builder
      .addCase(login.pending, (state) => {
        state.loading["login"] = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state) => {
        state.loading["login"] = false;
        state.error = null;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading["login"] = false;
        state.error = action.payload;
      });
  },
});

export const { setLoading, clearError, setError } = apiStatusSlice.actions;
export default apiStatusSlice.reducer;
